import {
  BillingPeriod,
  BudgetConfigurationInput,
  CouponFragment,
  PackageEntitlement,
  PaymentCollectionMethod,
  PriceFragment,
  SubscriptionCouponConfigurationInput,
  SubscriptionCouponDataFragment,
  SubscriptionMinimumSpendValueInput,
  TrialEndBehavior,
} from '@stigg-types/apiTypes';
import { EntitlementFields } from '../../../../../entitlements/components/entitlementSettings/types';
import { SubscriptionBillableFeatures } from '../priceBreakdown';
import { AddonType } from '../../../../../packages/addons/components/AddonTypeValue';
import { CouponStartOption } from './components/coupon/FutureStartInput';
import { CouponDuration } from '../../../../../coupons/components/createCoupon/CreateCouponForm';

export enum StartDateConfiguration {
  Now = 'now',
  EndOfBillingPeriod = 'endOfBillingPeriod',
  Custom = 'custom',
}

export type SubscriptionAddon = {
  id: string;
  refId: string;
  displayName: string;
  description?: string | null;
  quantity?: number;
  price?: PriceFragment | null;
  packageEntitlements?: Partial<PackageEntitlement>[] | null;
  addonType?: AddonType;
  dependencies?: SubscriptionAddon[] | null;
};

export type SubscriptionFormFields = {
  productId: string;
  billableFeatures?: SubscriptionBillableFeatures;
  billableFeaturesPriceOverride?: BillableFeaturesPriceOverride;
  addonsPriceOverride?: AddonsPriceOverride;
  billingPeriod?: BillingPeriod;
  billingCountryCode?: string | null;
  planId: string;
  resourceId: string;
  billingId?: string;
  startDateConfiguration: StartDateConfiguration;
  startDate: string;
  entitlements: EntitlementFields[];
  addons: SubscriptionAddon[];
  paidOneOffAddons?: SubscriptionAddon[];
  endDate?: Date;
  isTrial?: boolean;
  trialEndBehavior?: TrialEndBehavior;
  paymentMethod?: any;
  isInvoicePaid?: boolean;
  budget?: Partial<BudgetConfigurationInput>;
  couponRefId?: string;
  coupon?: CouponFragment | SubscriptionCouponDataFragment;
  couponConfiguration?: SubscriptionCouponConfiguration;
  customCoupon?: CustomCoupon;
  paymentCollectionMethod?: PaymentCollectionMethod;
  minimumSpend?: Partial<SubscriptionMinimumSpendValueInput>;
  invoiceDaysUntilDue?: number;
  billingIntegrationId?: string;
};

export type PlanPricePoints = { [key in BillingPeriod]?: PriceFragment[] };

export type BillableFeaturesPriceOverride = {
  [key in keyof SubscriptionBillableFeatures]: PriceFragment | null | undefined;
};

export type AddonsPriceOverride = {
  [addonId: string]: PriceFragment | null | undefined;
};

export type SubscriptionCouponConfiguration = SubscriptionCouponConfigurationInput & {
  startConfiguration: CouponStartOption;
};

export type CustomCoupon = Pick<
  CouponFragment,
  'type' | 'discountValue' | 'amountsOff' | 'percentOff' | 'durationInMonths'
> & {
  duration: CouponDuration;
};
